<template>
  <div class="card p-2">
    <div class="p-2">
      <div class="float-left"><b>Accounts</b></div>
      <button class="btn btn-sm btn-success float-right add-btn" title="Add Account" @click="openAddAccountModal">
        <i class="fa fa-plus"></i>
      </button>
    </div>
    <div class="p-2 d-flex">
      <div class="form-check-radio">
        <label class="form-check-label">
          <input class="form-check-input" v-model="searchBy" type="radio" name="searchBy" id="search" value="account">Accounts
          <span class="form-check-sign"></span>
        </label>
      </div><div class="form-check-radio ml-2">
        <label class="form-check-label">
          <input class="form-check-input" v-model="searchBy" type="radio" name="searchBy" id="search" value="domain">Websites
          <span class="form-check-sign"></span>
        </label>
      </div>
    </div>
    <div class="mb-2">
      <input type="text" :placeholder="`Search by ${searchBy === 'account' ? 'accounts' : 'websites' }`" class="form-control" v-model="search"/>
    </div>
    <div v-if="searchBy === 'account'" class="accounts-list" ref="accountContainer">
      <div @click="selectedAccount= row" v-for="(row, index) in allAccounts" :key="index" class="card bg-light cursor-pointer m-2 p-2 border is-shadowless">
        <div>
          {{ row.name }}
        </div>
      </div>
      <div class="mt-2" v-if="loading || zoneLoading">
        <div class="loader small_loader" style="width: 25px;height:25px">
        </div>
      </div>
    </div>
    <div v-if="searchBy === 'domain'" class="accounts-list" ref="accountContainer">
      <div @click="selectAccount(row)" v-for="(row, index) in allZones" :key="index" class="card bg-light cursor-pointer m-2 p-2 border is-shadowless">
        <div>
          {{ row.name }}
        </div>
      </div>
      <div class="mt-2" v-if="zoneLoading">
        <div class="loader small_loader" style="width: 25px;height:25px">
        </div>
      </div>
    </div>
    <add-account-modal />
  </div>
</template>

<script>
import _ from "lodash";
import addAccountModal from "./addAccountModal";

export default {
  name: "accountsList",
  props: ['value'],
  components: {addAccountModal},
  data () {
    return {
      allAccounts: [],
      allZones: [],
      accPage: 1,
      zonePage: 1,
      search: null,
      loading: true,
      zoneLoading: true,
      searchBy: 'account'
    }
  },
  computed: {
    selectedAccount: {
      get () {
        return this.value;
      },
      set (newValue) {
        this.$emit('input', newValue);
      }
    }
  },
  watch: {
    search () {
      this.loading=true
      this.zoneLoading=true
      this.handleSearch()
    },
    searchBy (val) {
      this.search = null
      if(val === 'domain'){
        this.allZones=[]
        this.zoneLoading=true
        this.fetchAllZones()
      }
      else if(val === 'account'){
        this.allAccounts=[]
        this.loading=true
        this.fetchAllAccounts()
      }
      this.checkScroll()
    }
  },
  mounted() {
    this.fetchAllAccounts()
    this.fetchAllZones()
    this.checkScroll();
  },
  methods: {
    selectAccount(row) {
      this.selectedAccount = {id: row.account.id, name: row.account.name, selectedZone: {...row} }
    },
    openAddAccountModal () {
      $('#addTenantAccount').modal('show');
    },
    async fetchAllAccounts(){
      try{
        let resp = await this.$http.post('tenant/fetch-accounts',{
          grant_type:'token',
          page: this.accPage,
          search: this.search,
        });
        if (resp.data.result.length < 20) {
          this.loading = false
          this.zoneLoading=false
        }
        this.allAccounts = [...this.allAccounts, ...resp.data.result]
        console.log(this.allAccounts)

      } catch (e) {
        console.log('Error from fetching all acounts under tenant' + e.toString())
      }
    },
    async fetchAllZones(){
      try{
        let resp = await this.$http.post('tenant/fetch-all-zones',{
          grant_type:'token',
          page: this.zonePage,
          search: this.search,
        });
        if (resp.data.result.length < 20) {
          this.zoneLoading = false
          this.loading=false
        }
        this.allZones = [...this.allZones, ...resp.data.result]
        console.log(this.allZones)

      } catch (e) {
        console.log('Error from fetching all zones under tenant' + e.toString())
      }
    },
    checkScroll () {
      if(this.searchBy === 'account'){
        this.$refs.accountContainer.onscroll = () => {
          let bottomOfWindow = this.$refs.accountContainer.scrollTop > this.$refs.accountContainer.offsetHeight;
          if (bottomOfWindow && this.loading) {
            this.getNextAccounts()
          }
        }
      }
      else if(this.searchBy === 'domain') {
        this.$refs.accountContainer.onscroll = () => {
          let bottomOfWindow = this.$refs.accountContainer.scrollTop > this.$refs.accountContainer.offsetHeight;
          if (bottomOfWindow && this.zoneLoading) {
            this.getNextZones()
          }
        }
      }

    },
    getNextAccounts: _.debounce(async function () {
      this.accPage++;
      this.fetchAllAccounts()
    }, 1000),
    getNextZones: _.debounce(async function () {
      this.zonePage++;
      this.fetchAllZones()
    }, 1000),
    handleSearch: _.debounce(async function () {
      if(this.searchBy === 'account') {
        console.log('inside account')
        this.accPage = 0
        this.loading=true
        this.allAccounts = []
        this.fetchAllAccounts()
      }
      else if(this.searchBy === 'domain'){
        this.zonePage = 0
        this.allZones = []
        this.loading=true
        this.fetchAllZones()
      }

    }, 500),
  }
}
</script>

<style scoped>

.cursor-pointer{
  cursor: pointer;
}
.accounts-list {
  height: 70vh;
  overflow-y: scroll;
}
.add-btn{
  width: 20px; height: 20px; padding: 3px !important;border-radius: 50%; margin: 1px
}
</style>